import { render } from "./LoginForm.organism.vue?vue&type=template&id=f270073a&scoped=true&bindings={\"userEmail\":\"setup\",\"userPassword\":\"setup\",\"v\":\"setup\",\"handleBlur\":\"setup\",\"handleOnSubmit\":\"setup\",\"userIcon\":\"setup\",\"lockIcon\":\"setup\"}"
import script from "./LoginForm.organism.vue?vue&type=script&lang=ts"
export * from "./LoginForm.organism.vue?vue&type=script&lang=ts"

import "./LoginForm.organism.vue?vue&type=style&index=0&id=f270073a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f270073a"

export default script